import { SSHService } from '../../../core/services/ssh.service';
import useService from '../../../injector/hooks/useService';
import DestinationsAPI from '../api/DestinationsAPI';

export function useGetDestinationApi() {
  const sshService = useService(SSHService);

  return DestinationsAPI.getDestination.bind(DestinationsAPI);
}
